import React, { Component } from 'react'

const menuLinks = [
    { title: 'About us', target: 'about' },
    { title: 'Film portfolio', target: 'film' },
    { title: 'Photography', target: 'photography' },
    { title: 'Music production', target: 'music' },
    { title: 'Services', target: 'services' },
    { title: 'Contact', target: 'contact' }
]

class SideMenu extends Component {
    render() {
        const { visible, onClick } = this.props
        return(
                <div className={visible ? 'sidemenu visible' : 'sidemenu hidden'}>
                        <div className="sidemenu-inner">
                          {menuLinks.map((link,index) => 
                              <button 
                                key={index} 
                                name={link.target}
                                onClick={onClick} 
                                >{link.title}</button>
                          )}
                        </div>
                </div>
        )
    }
}

export default SideMenu


// WEBPACK FOOTER //
// ./src/containers/app/SideMenu.js